<template>
<div>
    <v-img :src="require('@/assets/maya/servicios/headers/sorteos.jpg')" max-height="420" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                Sorteos de Calidad
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-regular" style="max-width:480px; line-height:1.3">
                <div>Sorting</div>
            </div>

            <div>
                <v-btn small text class="white--text ml-n4 mt-2" @click="$router.push('/servicios')">
                    <div class="d-flex align-center">
                        <v-icon size="12" color="white" class="mr-2 mt-1">fa-arrow-left</v-icon>
                        <div>Regresar a servicios</div>
                    </div>
                </v-btn>
            </div>
        </v-card>
    </v-img>

    <div class="white py-6 px-4 px-sm-0">
        <v-row class="">
            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="1">
                <p>
                    Los sorteos de calidad de MSO son servicios de clasificación e inspección de materiales para detectar piezas no conformes a través del ordenamiento y la categorización, de acuerdo a los criterios de calidad requeridos y esperados. 
                </p>

                <p>
                    Los sorteos se realizan pieza a pieza así que este servicio es efectivo, rápido y a la vez garantiza que los materiales y los productos estén libres de defectos y que cumplan al 100% con los requisitos de calidad.
                </p>

                <p>
                    MSO puede proporcionar estos servicios en nuestras instalaciones así como en las plantas de proveedores o del cliente, en los centros de distribución, en bodegas asignadas o en cualquier sitio limpio de materiales que nos indique el cliente.
                </p>

                <div class="mt-4 primary--text font-weight-bold">Beneficios:</div>
                <ul>
                    <li>Reducción de material defectuoso.</li>
                    <li>Reducción de costos de mano de obra y costos operativos.</li>
                    <li>Mejora la calidad de fabricación.</li>
                    <li>Reduce y detiene las fugas de calidad de las líneas de producción.</li>
                    <li>Permite obtener reportes con información más precisa y detallada para entender la eficiencia de los proyectos y definir mejoras continuas.</li>
                </ul>

                <p class="mt-4">
                    Los servicios de sorteo se pueden llevar a cabo en diferentes etapas de la producción: desde la clasificación de materia prima, hasta la certificación mediante labores de sorteo de ensambles, de sub-ensambles y de producto terminado.
                </p>
            </v-col>
        </v-row>
    </div>

    <!-- CONTACT FORM -->
    <ContactForm />
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        ContactForm
    },
    metaInfo: {
      title: 'Sorteos de Calidad'
    }
}
</script>

